import React, { useCallback } from 'react';
import { SpecialSavings } from '@one-thd/sui-icons';
import { Typography, Button } from '@one-thd/sui-atomic-components';
import {
  usePromoStore, useDimensionsStore, useDigitalDataStore, useProductInfoStore
} from '../../../store';
import logNewRelicCustom from '../../../utils/logNewRelicCustom';
import { ANALYTICS_EVENTS, NEW_RELIC_EVENTS, STACK_BUILDER } from '../../../constants';

const PromoBanner = () => {
  const openDrawer = usePromoStore((state) => state.openDrawer);
  const fulfillmentProducts = usePromoStore((state) => state.fulfillmentProducts);
  const productInfo = useProductInfoStore((state) => state.productInfo);
  const stackDimensions = useDimensionsStore((state) => state.stackDimensions);

  const trackModalLinkClickEvent = useDigitalDataStore((state) => state.trackModalLinkClickEvent);

  const handleOpenDrawer = useCallback(() => {
    openDrawer();
    trackModalLinkClickEvent(
      ANALYTICS_EVENTS.VIEW_MY_PROMOS,
      stackDimensions,
      `${productInfo?.brand} ${STACK_BUILDER.TYPE}`
    );
    logNewRelicCustom(NEW_RELIC_EVENTS.LOAD_STACK_SUMMARY, fulfillmentProducts);
    logNewRelicCustom(NEW_RELIC_EVENTS.LOAD_STACK_DIMENSIONS, stackDimensions);
  }, [stackDimensions]);

  return (
    <div className="sui-flex sui-justify-between sui-w-full sui-pt-3 sui-bg-primary">
      <div className="sui-flex">
        <span className="sui-flex sui-pr-3 sui-self-center">
          <SpecialSavings color="brand" />
        </span>
        <div>
          <Typography variant="body-xs" weight="bold">{'You\'ve Unlocked Savings!'}</Typography>
          <Typography variant="body-xs">{'Check out the different promotions you\'re stacking up'}</Typography>
        </div>
      </div>
      <span>
        <Button fullWidth variant="secondary" onClick={handleOpenDrawer}>
          View Promotions
        </Button>
      </span>
    </div>
  );
};

export default PromoBanner;
